import { CancelButton } from '../components/CancelButton/CancelButton';
import styles from './WaitingManualPayment.module.css';

interface Props {
  popupBlockedUrl?: string;
  popupBlocked?: boolean;
  sseDisconnected?: boolean;
  onRefresh?: () => void;
  onOpenCheckout?: (url: string) => void;
  onCancel?: () => void;
}

export const WaitingManualPayment = ({
  popupBlockedUrl,
  popupBlocked,
  sseDisconnected,
  onRefresh,
  onOpenCheckout,
  onCancel,
}: Props) => {
  return (
    <div
      className={styles.container}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={styles.spinner} aria-label="Loading">
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.spinnerSvg}
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M60 110C87.6142 110 110 87.6142 110 60C110 32.3858 87.6142 10 60 10C32.3858 10 10 32.3858 10 60C10 87.6142 32.3858 110 60 110ZM60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z"
            fill="url(#paint0_linear_waiting)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_waiting"
              x1="60"
              y1="-3.25718e-06"
              x2="60"
              y2="120"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#06A4F3" />
              <stop offset="1" stopColor="white" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      <h2 className={styles.title}>
        Finish the payment in the manual mode page
      </h2>
      <p className={styles.message}>
        Payment page should be open on a new browser tab
      </p>
      {sseDisconnected && (
        <div className={styles.sseWarning}>
          <span>
            Connection lost. Payment status may not update automatically.
          </span>
          <button className={styles.refreshButton} onClick={onRefresh}>
            Refresh
          </button>
        </div>
      )}
      {popupBlockedUrl && (
        <p className={styles.popupBlocked}>
          {popupBlocked
            ? 'Payment page could not open automatically. '
            : 'Accidentally closed the payment page? '}
          <button
            type="button"
            onClick={() => onOpenCheckout?.(popupBlockedUrl)}
            className={styles.popupBlockedLink}
          >
            {popupBlocked ? 'Open it here' : 'Go back to it here'}
          </button>
        </p>
      )}
      {onCancel && (
        <div className={styles.cancelWrapper}>
          <CancelButton onClick={onCancel} />
        </div>
      )}
    </div>
  );
};
